/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Incomplete_BodyInputs */

const en_us2_profile_incomplete_body = /** @type {(inputs: Profile_Incomplete_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The plan is built from your answers. When one is missing, it comes out more generic.`)
};

const pt_br2_profile_incomplete_body = /** @type {(inputs: Profile_Incomplete_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O plano é montado com as suas respostas. Quando falta alguma, ele sai mais genérico.`)
};

const es_419_profile_incomplete_body = /** @type {(inputs: Profile_Incomplete_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El plan se arma con tus respuestas. Cuando falta alguna, sale más genérico.`)
};

const pt_pt2_profile_incomplete_body = /** @type {(inputs: Profile_Incomplete_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O plano é criado com as tuas respostas. Quando falta alguma, fica mais genérico.`)
};

const fr_fr2_profile_incomplete_body = /** @type {(inputs: Profile_Incomplete_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le programme est construit à partir de tes réponses. Quand il en manque une, il est plus générique.`)
};

const de_de2_profile_incomplete_body = /** @type {(inputs: Profile_Incomplete_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Plan wird aus deinen Antworten gebaut. Fehlt eine, fällt er allgemeiner aus.`)
};

const it_it2_profile_incomplete_body = /** @type {(inputs: Profile_Incomplete_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La scheda si basa sulle tue risposte. Quando ne manca qualcuna, viene più generica.`)
};

/**
* | output |
* | --- |
* | "The plan is built from your answers. When one is missing, it comes out more generic." |
*
* @param {Profile_Incomplete_BodyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_incomplete_body = /** @type {((inputs?: Profile_Incomplete_BodyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Incomplete_BodyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_incomplete_body(inputs)
	if (locale === "es-419") return es_419_profile_incomplete_body(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_incomplete_body(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_incomplete_body(inputs)
	if (locale === "de-DE") return de_de2_profile_incomplete_body(inputs)
	if (locale === "it-IT") return it_it2_profile_incomplete_body(inputs)
	return en_us2_profile_incomplete_body(inputs)
});
export { profile_incomplete_body as "profile.incomplete_body" }